import * as S from "./style";
import { useEffect, useState } from "react";
import axiosInstance from "services/axiosInstance";
//Interface
import { ICard } from "Interfaces/ICard";
//Utils
import { CurrencyFormat } from "utils/CurrencyFormat";

interface ICreat {
  subtotal: number;
  register: any,
  errors: any,
  reset: any,
  resetField: any,
  index?: number,
}

export default function CreditCard({
  subtotal,
  register,
  reset,
  errors,
  index = 0
}: ICreat) {
  const [card, setCard] = useState<ICard[]>([]);

  /**
   * Retorna o valor do total + a taxa da parcela.
   * @param total
   * @param numberInstallm
   * @returns {number}
   */
  const calculateInstallments = (installm: number) => {
    const total = subtotal;
    const result = total + (total * installm / 100);
    return result;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get("card");
        setCard(response.data);
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    fetchData();
  }, []);

  // if (!isOpenCard) {
  //   reset();
  // }

  return (
    <S.Container>
      <S.Content>
        <S.SeparateDiv>
          <S.FormInput>
            <S.Label htmlFor="qtd_installment">
              Parcelas (até 6x) <span>*</span>
            </S.Label>
            <S.Select
              id={`card_id.${index}`}
              {...register(`card_id.${index}`, { required: true })}
            >
              <option value="" disabled selected hidden>
                Selecione
              </option>
              {
                card.map((val, index) => {
                  const value = index + 1;
                  const value_id = val.id;

                  const totalWithInterest = calculateInstallments(Number(val.interest_rate));

                  const installmentValue = CurrencyFormat(totalWithInterest / value);
                  return (
                    <option key={value_id} value={value_id}>
                      {val.number_installment}x {installmentValue} - {CurrencyFormat(totalWithInterest)}
                    </option>
                  )
                })
              }
            </S.Select>
            {errors[`card_id.${index}`] && <S.InforErro>Campo Obrigatório</S.InforErro>}
          </S.FormInput>
        </S.SeparateDiv>
      </S.Content>
    </S.Container>
  );
}
